import React, {Fragment, useEffect,  useState} from 'react';
import PropTypes from "prop-types";
import moment from "moment";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {useForm} from "react-hook-form";
import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getPostDetails, saveNewPost, updatePost, deletePost} from "root/DataFunctions/PostDataFns";
import {getMessageReplyThread} from "root/DataFunctions/MessageDataFns";
import {getUserRoles} from "root/DataFunctions/UserDataFns";
import DatePickerControl from "root/ReactHookForm/ControlWrappers/DatePickerControl";
import SingleFilePicker from "root/ReactHookForm/ControlWrappers/SingleFilePicker";
import DemoModal from "root/DemoModal";
import {getChildImageUrl, getOpenImageUrl} from "root/DataFunctions/ChildDataFns";
import {PostStatus, IconPath, MessageType} from "root/DataFunctions/Constants";
import DropdownChildSiblings from "root/ReactHookForm/ControlWrappers/DropdownChildSiblings";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownMessageContacts from "root/ReactHookForm/ControlWrappers/DropdownMessageContacts";
import phpVars from 'phpVars';

const ModalAddPost = (props) =>
{
    const [buttonState, setButtonState] = useState ('') ;
    const [data, setData] = useState({ isLoading: props.post_id !== null, data: [] });
    const [ messageReplyThread, setMessageReplyThread ] = useState ('') ;
    const [roleData, setRoleData] = useState({ isLoading: props.child_uid !== null, data: [] });
    const [newImageData, setNewImageData] = useState( null );
    const [multipleImageData, setMultipleImageData] = useState( [] );
    const [imageNo, setImageNo] = useState( 0 );
    const [imagePickerIndexToTrigger, setImagePickerIndexToTrigger] = useState ( 0 );
    const [disable, setDisable] = React.useState(false);
    const messageTypeDescription = props.messageType === MessageType.MESSAGE_TYPE_LIFESTORY ?  'Post' : 'Message';

    ////////////////////////
    /// Get/Set Data
    ////////////////////////
    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                post: {
                    child_uid: { value : 0 } , /* This field uses raw dropdown-select objects */
                    to: '',
                    from: '',
                    title: '',
                    text: '',
                    link: '',
                    event_date: null,
                    document: '',
                    attach_image: 0,
                    editor_comment: '',
                    letterbox_comment: '',
                    reply_to_post_id: 0
                }
            }
        });

    const watchLink = watch("post.link", '' );
    const childSelected = watch("post.child_uid", '' );
    const watchDocument = watch("post.document");

    const getDefaultData = () =>
    {
        return {
            title: '',
            text: '',
        }
    }

    useEffect(() =>
    {
        if ( props.post_id !== null)
        {
            getPost();
        }
        else
        {
            setData({ isLoading: false, data: getDefaultData() });
        }

        //LIF1519 - don't check for incoming mail
        if(props.child_uid !== null && props.child_uid !== undefined && props.child_uid !== 'all' && phpVars.unenc_user_id !== +props.child_uid)
        {
            checkEditor(phpVars.user_id, props.child_uid);
        }

    }, []);

    useEffect(() =>
    {
        //LIF1519 - don't check for incoming mail
        if(childSelected !== undefined && childSelected !== '' && childSelected.value !== 0 && phpVars.unenc_user_id !== +childSelected.value)
        {
            checkEditor(phpVars.user_id, childSelected.value);
        }

    }, [childSelected]);

    //Get the posts details
    const getPost = (data) =>
    {
        getPostDetails(props.post_id, (response) =>
        {
            let postData = getDataFromResponse(response)[0] ;
            let event_date_object = moment(postData.event_date).toDate();

            //Get any images and set picker and counter (for edit mode), unless we are replying to a message
            if (postData.image_array !== null && props.mode !== 'reply')
            {
                setMultipleImageData(postData.image_array)
                handleSetImagePickerIndex(postData.image_array);
                setImageNo(postData.image_array.length)
            }

            //Message Reply Thread
            let replyToPostId = "";
            let replySubject = "";

            //Check if this is the first reply or part of a thread
            if (postData.reply_to_post_id) {
                replyToPostId = postData.reply_to_post_id;
                replySubject = postData.title;
            } else {
                replyToPostId = postData.post_id;
                replySubject = "RE: " + postData.title;
            }

            // This checks if the message is a reply
            if(props.mode === 'reply') {
                setValue ( 'post',
                    { child_uid: {value: postData.unenc_recipient_user_id},
                        to: postData.known_as,
                        from: postData.post_by,
                        title : replySubject,
                        text : "",
                        editor_comment: postData.approval_comment,
                        document: postData.document_array[0],
                        reply_to_post_id: replyToPostId,
                    }) ;
            }
            else
            {
                setValue ( 'post',
                    { child_uid: {value: postData.unenc_recipient_user_id},
                        title : postData.title,
                        text : postData.text,
                        link: postData.link,
                        event_date: event_date_object,
                        document: postData.document_array[0],
                        editor_comment: postData.approval_comment,
                        letterbox_comment: postData.letterbox_comment,
                    }) ;
            }

            setData({ isLoading: false, data: postData });

            const date_created = props.mode === 'reply'? null: postData.date_created;

            getMessageReplyThread(date_created, replyToPostId, (response) =>
            {
                const messageTrailData = getDataFromResponse(response);
                setMessageReplyThread(messageTrailData);
            });
        });
    }

    //Get the posts details
    const checkEditor = (current_user_id, child_uid) =>
    {
        setRoleData({ isLoading: true, data: []}) ;

        getUserRoles( current_user_id, child_uid, (response) =>
        {
            let roleData = getDataFromResponse(response)[0] ;
            setRoleData({ isLoading: false, data: roleData });
        });
    }

    ////////////////////////
    /// Action Processing create, edit etc..
    ////////////////////////

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doCreatePost = ( formData ) =>
    {
        setDisable(true);

        saveNewPost (props.child_uid, formData, props.messageType, (response) =>
        {
            let message_text = '';
            let mode_text = '';

            switch(+(formData['post']['status'])){
                case PostStatus.NOT_SENT:
                    message_text = messageTypeDescription + ' Draft Created - Ok';
                    mode_text = 'draft';
                    break;
                case PostStatus.PENDING:
                    message_text = messageTypeDescription + ' Held - Ok';
                    mode_text = 'draft';
                    break;
                case PostStatus.HELD:
                    message_text = messageTypeDescription + ' Archived - Ok';
                    mode_text = 'draft';
                    break;
                default:
                    message_text = messageTypeDescription + ' Submitted - Ok';
                    mode_text = 'create';
            }

            bootbox.alert({
                size: "small",
                message: message_text,
                callback: (result =>
                {
                    props.onSaveCompleted ('saved');
                    props.onClose() ;
                })
            })

        });
    }

    const doUpdatePost = ( formData ) =>
    {
        const message_text = +(formData.post['status']) == PostStatus.NEW ? messageTypeDescription + ' Submitted - Ok' : messageTypeDescription + ' Updated - Ok';

        updatePost (props.child_uid, props.post_id, formData, props.messageType, (response) =>
        {
                bootbox.alert({
                size: "small",
                message: message_text,
                callback: (result =>
                {
                    props.onSaveCompleted ('saved');
                    props.onClose() ;
                })
            })
        });
    }

    const doDelete = ( callback ) =>
    {
        deletePost (props.child_uid, props.post_id, (response) =>
        {
            props.onSaveCompleted ('saved');
            props.onClose() ;
        });
    }

    const validateDropdownDecision = ( val ) =>
    {
        if ( val.idusers === undefined )
        {
            return "You must select someone to send the post to." ;
        }
    }

    const validateEventDate = ( val ) =>
    {
        if ( val === null )
        {
            return "Please Select an Event Date." ;
        }
    }

    const onSubmit = (data, status) => {

        switch (props.mode)
        {
            case 'create' :
            case 'reply':
                const createImageData = removeBlanksFromImageArray();
                data.post['image'] = createImageData;
                data.post['event_date'] = moment(data.post.event_date).format("DD/MM/yyyy");
                data.post['status'] = status;

                doCreatePost(data);
                break;

            case 'edit' :
                const editImageData = removeBlanksFromImageArray();
                data.post['image'] = editImageData;
                data.post['event_date'] = moment(data.post.event_date).format("DD/MM/yyyy");
                data.post['status'] = status;

                doUpdatePost(data, status);
                break;

            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to delete this " + messageTypeDescription + "?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const onClickSaveButton = (status) => {
        handleSubmit(onSubmit)(status);
    }

    ////////////////////////
    /// Buttons & Titles
    ////////////////////////

    const submitButtonText = () => {
        switch (props.mode){
            case 'view':
                return 'Close';
                break;
            case 'edit':
                if(+(data.data.status) === PostStatus.RETURNED){
                    return 'Re-Submit';
                }
                else{
                    return 'Submit';
                }

                break;
            case 'create':
            case 'reply':
                return 'Submit';
                break;
            case 'delete':
                return 'Delete';
                break;
        }
    } ;

    const Title = ( mode ) =>
    {
        let titleString = '';

        switch(mode.mode){
            case 'view':
                titleString = 'View ' + messageTypeDescription;
                break;
            case 'edit':
                titleString = 'Edit ' + messageTypeDescription;
                break;
            case 'create':
                titleString = 'Create ' + messageTypeDescription;
                break;
            case 'reply':
                titleString = 'Reply to ' + messageTypeDescription;
                break;
            case 'delete':
                titleString = 'Delete ' + messageTypeDescription;
                break;

        }

        return <h3>{titleString}</h3>
    }

    const isViewOnly = props.mode === 'view';

    const getSubmitButtonText = ( mode ) =>
    {
        return submitButtonText() ;
    }

    const getSubmitButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const saveButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} id='save' type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={disable} className={getSubmitButtonStyle(mode)}>Save Draft<i className="et-save" /></button>
        )
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} id='submit' type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={disable} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i className="et-save" /></button>
        )
    }

    const holdButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} id='hold' type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={disable} className={getSubmitButtonStyle('delete')}>Hold<i className="et-save" /></button>
        )
    }

    const archiveButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} id='hold' type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={disable} className={getSubmitButtonStyle('delete')}>Archive<i className="et-save" /></button>
        )
    }

    ////////////////////////////////
    /// Image Processing
    ////////////////////////////////

    const removeBlanksFromImageArray = () => {
        const cleanedImageData = multipleImageData.filter(element =>
            element !== undefined && element !== null
        );

        return cleanedImageData;
    }

    const removeBlanksFromArray = (array) => {
        const cleanedImageData = array.filter(element =>
            element !== undefined && element !== null
        );

        return cleanedImageData;
    }

    const handleSetImagePickerIndex = (imageArray) => {
        // first undefined element
        for (var i = 0; i < 4; i ++ ) {
            if (imageArray[i] == undefined) {
                setImagePickerIndexToTrigger(i);
                break;
            }
        }
        setImageNo(removeBlanksFromArray(imageArray).length)
    }

    const handleRemoveImage = (doc_id) => {
        // Does not remove element, but sets it to undefined
        // Undefined elements are simulated as removed element
        let tempImageData = [...multipleImageData];
        tempImageData[doc_id] = undefined;
        setMultipleImageData(tempImageData);
        handleSetImagePickerIndex(tempImageData);

        // remove undefined elements
        const cleanedTempImageData = tempImageData.filter(element => {
            return element !== undefined;
        });

        setImageNo(cleanedTempImageData.length);
    }

    const onMultipleImageChange = ( imageUrl, index ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            let tmpImageData = [...multipleImageData];
            tmpImageData[index] = reader.result;
            setMultipleImageData ( tmpImageData );
            handleSetImagePickerIndex( tmpImageData );

        }
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
        }
    }

    const handleUnsetDocument = () => {
        setValue('post.document', "");
        const dataHolder = { ...data.data, document_array: [] };
        setData({ ...data, data: dataHolder });
    }

    const renderDemoModal = () => {
        const numberOfModals = 4;
        // The width of modals with undefined values in multipleImageData are set to 0 to hide them. All the ImagePicker buttons have the same x and y coordinates.
        // The ImagePicker button of the first modal with undefined value in multipleImageData is shown, the rest are hidden
        return [...Array(numberOfModals).keys()].map((key) => (
            <div className="post-all-image-wrap" key={key}>
                <div className={multipleImageData?.[key] === undefined ? "post-all-image" : "post-all-image post-all-image_show"}>
                    <DemoModal
                        image_id={multipleImageData?.[key] }
                        provider_id={1}
                        dimensions={110}
                        onImageChange={onImageChange}
                        onMultipleImageChange={onMultipleImageChange}
                        imageIndex={key}
                        visble={false}
                        multipleImageData={multipleImageData}
                        imagePickerIndexToTrigger={imagePickerIndexToTrigger}
                        imageNo={imageNo}
                    />

                    <span className="post-image-remove"><i onClick={()=>handleRemoveImage( key )} className='icon-close'/></span>
                    <div className="post-all-image-overlay"></div>
                </div>
            </div>
        ));
    }

    ////////////////////////////////
    /// Render Form
    ////////////////////////////////
    const getDocumentUrl = (  ) =>
    {
        let url = '/getFile.php?enc_docid=' + data.data.document_array[0];
        return url;
    }

    const getDocumentIcon = (  ) =>
    {
        let icon = IconPath.ICON_DOCUMENT;
        return icon;
    }

    const validateLinkUrl = (readOnlyMode, value) => {
        value = value.trim();
        
        if (value === "" || readOnlyMode === "readonly") {
            return true;
        } else {
            let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            let match = value.match(regExp);
            if (match && match[2].length == 11) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    const viewImage = () => {
        return(
            <fragment>
                <a href="https://picsum.photos/200/300" target="_blank">
                    <img src="https://picsum.photos/200/300" width="200" height="300"/>
                </a>
            </fragment>
        )
    }

    const getQuotaDetails = () =>
    {
        let response = {
            canSend: true
        }

        if ( roleData.isLoading === false  )
        {
            if ( roleData.data.comms_plan !== undefined )
            {
                const plan = roleData.data.comms_plan ;

                if ( plan.allow_send === false )
                {
                    response.canSend = false ;
                    response.max_allowed_count = +(plan.max_allowed_count) ;
                    response.sent_this_period = +(plan.sent_this_period) ;

                    const periodicity_id = +(plan.periodicity_id) ;
                    let period_type = '' ;

                    const msg = response.max_allowed_count === 1 ? 'message' : 'messages' ;

                    switch ( periodicity_id )
                    {
                        case 1:
                            period_type = ' this year';
                            break ;
                        case 2:
                            period_type = ' in this six-month period';
                            break ;
                        case 3:
                            period_type = ' this month';
                            break ;
                        case 4:
                            period_type = ' this quarter';
                            break ;
                        case 5:
                            period_type = ' this week';
                            break ;
                    }

                    response.message = "Sorry. Your communications plan only allows " + response.max_allowed_count + ' ' + msg + ' to be sent' + period_type + ', and you have already exceeded this allowance.' ;
                }
            }
        }

        return response ;
    }

    const renderHookForm = ( prop )  =>
    {
        //Read Only
        const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '' ;

        //Dropdowns
        const dropDownReadOnly =  props.mode !== 'create' &&  props.mode !== 'reply' ? 'readonly' : '' ;
        const dropDownValidation =  props.mode !== 'create' && props.mode !== 'reply' ? null : validateDropdownDecision ;
        const hasSiblingDropdown =  props.child_uid === null ;

        //Editor and Letterbox comments
        const hasEditorComment = data.data.approval_comment !== undefined && data.data.approval_comment !== '' && data.data.approval_comment !== null;
        const hasLetterboxComment = data.data.letterbox_comment !== undefined && data.data.letterbox_comment !== '' && data.data.letterbox_comment !== null;
        const showEditorComment = +data.data.status === PostStatus.RETURNED && hasEditorComment && (props.mode === 'edit' || props.mode === 'view');
        const showLetterboxComment = +data.data.status === PostStatus.RETURNED && hasLetterboxComment && (props.mode === 'edit' || props.mode === 'view');

        //Status Buttons
        const showSaveButton = !isReadOnly && +data.data.status !== PostStatus.APPROVED && +data.data.status !== PostStatus.PENDING && +data.data.status !== PostStatus.HELD;
        const showHoldButton = !isViewOnly  && roleData.data.is_editor && +data.data.status !== PostStatus.PENDING && props.messageType===MessageType.MESSAGE_TYPE_LIFESTORY;
        const showArchiveButton = !isViewOnly  && roleData.data.is_editor && +data.data.status !== PostStatus.HELD && props.messageType===MessageType.MESSAGE_TYPE_LIFESTORY;
        const showSubmitButton = !isViewOnly && (+data.data.status !== PostStatus.APPROVED || +props.messageType===MessageType.MESSAGE_TYPE_MESSAGE);

        //Attachments
        const hasImage = data.data.image_array !== undefined && (data.data.image_array.length > 0);
        const hasDocument = data.data.document_array !== undefined && (data.data.document_array.length > 0 || data.data.attached_pdf_document_id != null);
        const hasLink = isReadOnly && (data.data.link != null && data.data.link !== '');
        const hasAttachment = hasImage || hasDocument || hasLink;

        const commsPlanQuota = getQuotaDetails() ;

        const msgStyle = { fontSize: 'larger', marginTop: '20px'} ;

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    { ( commsPlanQuota.canSend === false && props.mode !== 'view' ) &&
                        <Fragment>
                            <div style={msgStyle}>{commsPlanQuota.message}</div>
                            <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                                <button onClick={onClickCancel} className="btn btn-secondary">Close<i
                                    className="et-arrow-bold-left"/></button>
                            </div>
                        </Fragment>
                    }

                    { (commsPlanQuota.canSend === true || props.mode === 'view' ) &&
                        <Fragment>
                            {(hasSiblingDropdown || props.adultPost) && !isReadOnly && props.mode !== 'reply' && <div>
                            <label>To</label>
                                {props.adultPost && <DropdownMessageContacts readOnly={dropDownReadOnly} name='post.child_uid' validate={dropDownValidation} control={control} options={{isRawValue: true}} messageType={props.messageType}/>}
                                {!props.adultPost && <DropdownChildSiblings readOnly={dropDownReadOnly} name='post.child_uid' validate={dropDownValidation} control={control} options={{isRawValue: true}}/>}
                                { formErrors.post?.child_uid && <ErrorDiv>{formErrors.post.child_uid.message}</ErrorDiv>}
                            </div>}

                            <label>Title</label>
                            <input readOnly={readOnlyMode} className='form-control' name='post.title' id='title' {...register("post.title", { required: true})} />
                            { formErrors.post?.title && <ErrorDiv>Please enter a title</ErrorDiv> }

                            <label>Text</label>
                            <textarea readOnly={readOnlyMode} style={{minHeight: '10em'}} name='post.text' className='form-control' id='text' {...register("post.text")} />

                            {props.messageType===MessageType.MESSAGE_TYPE_LIFESTORY && <div>
                                <label>Event Date</label>
                                <DatePickerControl name='post.event_date' control={control} validate={validateEventDate} placeHolder='Please Select Date' readOnly={readOnlyMode}  />
                                { formErrors.post?.event_date && <ErrorDiv>{formErrors.post.event_date.message}</ErrorDiv> }
                            </div>}

                            {isReadOnly && hasAttachment && <div><label>Attachments</label></div>}

                            {!isReadOnly && <div>
                                {props.messageType===MessageType.MESSAGE_TYPE_LIFESTORY && <div><h4 style={{marginTop: '20px'}}>Attachments</h4>
                                    <small>(You can add up to 4 Images OR a video link AND a document)</small></div>}

                                {props.messageType===MessageType.MESSAGE_TYPE_MESSAGE && <div><h4 style={{marginTop: '20px'}}>Attachments</h4>
                                    <small>(You can add up to 4 Images AND a document)</small></div>}
                            </div>}

                            {!isReadOnly && <div className="profile-img-container-wrap profile-img-container-wrap_child">
                                <> {renderDemoModal()} </>
                            </div>}

                            {(isReadOnly && hasImage) && <div className="profile-img-container-wrap profile-img-container-wrap_child">
                                {(multipleImageData && isReadOnly) && multipleImageData.map((imageData)=>{
                                    return (
                                        <Fragment>
                                            <div className="profile-img-wrap">
                                                {isReadOnly &&
                                                    <a href={getOpenImageUrl(imageData, data.data.user_id)} target="_blank">
                                                        <img src={getChildImageUrl(imageData, data.data.user_id)} onClick={() => viewImage(imageData)} alt={'Child Image'}/>
                                                    </a>
                                                }
                                            </div>
                                        </Fragment>
                                    )
                                })}
                            </div>}

                            { imageNo === 0 && props.messageType===MessageType.MESSAGE_TYPE_LIFESTORY && <div style={{marginBottom: '20px'}}>
                                <label>Youtube Video Link (Example:"https://www.youtube.com/watch?v=75NQK-Sm1YY")</label>
                                <input
                                    readOnly={readOnlyMode}
                                    className='form-control'
                                    id='link'
                                    {...register("post.link", {
                                        validate: value => validateLinkUrl(readOnlyMode, value) || 'Link is invalid'
                                    })}
                                />

                                { formErrors.post?.link && <ErrorDiv>{formErrors.post.link.message}</ErrorDiv> }
                            </div>}

                            <div>
                                {(props.mode !== 'create' && props.mode !== 'reply' && hasDocument && watchDocument !== '' ) &&
                                    <div>
                                        <div style={{position: 'relative', marginRight: '5px', marginBottom: '10px', marginTop: '10px'}}>
                                            <a href={getDocumentUrl()} target="_blank" ><img alt="document" width="70" src={getDocumentIcon()}/></a>
                                            {!isReadOnly &&<div>
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-right">Remove Document</Tooltip>}>
                                                    <span onClick={() => handleUnsetDocument()} style={{position: 'absolute', top: '-15px', fontSize: '2.3rem', color: 'red', lineHeight: '8px', cursor: 'pointer'}}>x</span>
                                                </OverlayTrigger>
                                            </div>}
                                        </div>
                                    </div>
                                }

                                {!isReadOnly && <div>
                                    <label>Add a Document</label>
                                    <SingleFilePicker name='post.document' control={control } options={{ maxSizeMb: 20, accept: ['.doc', '.pdf', '.docx']}} unsetDocument={handleUnsetDocument}/>
                                </div>}
                            </div>

                            {showEditorComment &&
                                <div>
                                    <label>Editor Comment</label>
                                    <textarea readOnly='readOnly' style={{minHeight: '5em'}} name='post.editor_comment' className='form-control' id='editor_comment' {...register("post.editor_comment") } />
                                </div>
                            }

                            {showLetterboxComment  &&
                                <div>
                                    <label>Letterbox Comment</label>
                                    <textarea readOnly='readOnly' style={{minHeight: '5em'}} name='post.letterbox_comment' className='form-control' id='letterbox_comment' {...register("post.letterbox_comment") } />
                                </div>
                            }

                            {!data.isLoading && messageReplyThread && props.messageType === MessageType.MESSAGE_TYPE_MESSAGE && data.data.reply_to_post_id !== null && props.mode !== "edit" &&
                                messageReplyThread.map((post) =>
                                    <div key={post.post_id} className="reply-thread-modal">
                                        <p>From: {post.posted_by_name}</p>
                                        <p>Sent: {post.posted_date}</p>
                                        <p>To: {post.known_as}</p>
                                        <p>Subject: {post.title}</p>
                                        <div className="reply-thread-modal-body">
                                            <p className="txt">{post.text}</p>
                                        </div>
                                    </div>
                                )}

                            <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                                <button onClick={onClickCancel} className="btn btn-secondary">Close<i className="et-arrow-bold-left" /></button>
                                { showSaveButton && saveButton(props.mode, () => onClickSaveButton(PostStatus.NOT_SENT))}
                                { showHoldButton && holdButton(props.mode, () => onClickSaveButton(PostStatus.PENDING))}
                                { showArchiveButton && archiveButton(props.mode, () => onClickSaveButton(PostStatus.HELD))}
                                { showSubmitButton && submitButton(props.mode, () => onClickSaveButton(PostStatus.NEW))}
                            </div>

                        </Fragment>
                    }
                </form>

            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && props.mode !== 'approve' && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddPost;

ModalAddPost.defaultProps =
{
    width: '600px'
}

ModalAddPost.propTypes = {
    child_uid: PropTypes.string,
    post_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
